import { render, staticRenderFns } from "./CategoriesSideMenu.vue?vue&type=template&id=1f4f83e3&scoped=true"
import script from "./CategoriesSideMenu.vue?vue&type=script&lang=js"
export * from "./CategoriesSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CategoriesSideMenu.vue?vue&type=style&index=0&id=1f4f83e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4f83e3",
  null
  
)

export default component.exports